export default {
  'ModalImageCropper.save': { en: 'Save', fr: 'Sauver' },
  'ModalImageCropper.pressAndDragToSelectArea': {
    en: 'Press and drag to select area',
    fr: 'Appuyez et faites glisser pour sélectionner la zone',
  },
};
